import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@ferris/react/components/button';
import { Loader } from '@ferris/react/components/loader';

export const SubmitButton = (props) => {
    const {
        animated, disabled, label, onClick, 'data-wdio': dataWdio, htmlButtonType, small
    } = props;
    const ButtonToUse = Button;
    return (
        <ButtonToUse
            isFullWidth
            classes="ulx-form__buttonbox"
            htmlButtonType={htmlButtonType}
            type="primary"
            data-wdio={dataWdio}
            id="leadFormSubmitBtn"
            onClick={onClick}
            disabled={disabled}
            small={small}
        >
            { animated
                ? (
                    <Loader
                        inline
                        size="mini"
                        visible
                        title={label}
                    />
                )
                : label }
        </ButtonToUse>
    );
};

SubmitButton.defaultProps = {
    animated: false,
    disabled: false,
    htmlButtonType: 'button',
    small: false
};

SubmitButton.propTypes = {
    animated: PropTypes.bool,
    disabled: PropTypes.bool,
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    'data-wdio': PropTypes.string.isRequired,
    htmlButtonType: PropTypes.string,
    small: PropTypes.bool
};

export default SubmitButton;
